<template>
  <div>
    <div v-if="!errorMsg"
         class="tarif-tabs-page">
      <div class="desktop-tabs-container">
        <DeviceSpecificationTabSelect :selectedTab="selectedTab"
                                      @click="setTab"
                                      use-translations
                                      :tabList="tabList"/>
        <base-tabs v-model="selectedTab" hide-tabs>
          <base-tab-page v-for="tabPage in tabList"
                         :key="`page${tabPage.key}`"
                         :name="tabPage.key"
                         class="addon-card-container">
            <div v-for="(addon, index) in products" :key="index" class="addon-card">
              <PlpAddonCard :addon="addon"/>
            </div>
          </base-tab-page>
        </base-tabs>
      </div>
      <TariffListMobileNav @navTo="setTab"
                           :tariffList="tabList"
                           :windowWidth="windowWidth"
                           use-translations
                           :step="navToChild"/>
      <div class="mobile-tabs-container">
        <div v-for="(addon, index) in products" :key="index">
          <PlpAddonCard :addon="addon"/>
        </div>
      </div>
    </div>
    <div v-else class="error-container">
      <img src="/assets/images/toast-icon-warning-desktop.svg" alt="warning-icon">
      {{ $t('plpAddonsPage.pageLoadError') }}
    </div>
  </div>
</template>

<script>

import DeviceSpecificationTabSelect from '../../../components/pdp/device-specification-tab-select'
import TariffListMobileNav from '../../../components/tariff-list/TariffListMobileNav'
import PlpAddonCard from '../../../components/plp-addons-list/plp-addon-card'
import BaseTabs from '../../../components/base/tabs/base-tabs'
import BaseTabPage from '../../../components/base/tabs/base-tab-page'
import { fetchTariffAddons } from '../../../api/tariffAddons'
import {
  tabListMobile,
  tabListTv,
  tabListBox,
  addonTypes,
  tabListMRoaming,
  tabListOtherRoaming,
  tabListMSat
} from './config/addonTabList'

export default {
  name: 'view-addons-list-page',
  components: { DeviceSpecificationTabSelect, BaseTabs, BaseTabPage, TariffListMobileNav, PlpAddonCard },
  props: {
    segment: String,
    addonType: String
  },
  data () {
    return {
      selectedTab: null,
      navToChild: 0,
      windowWidth: window.innerWidth,
      urlObj: {},
      products: [],
      errorMsg: false,
      tabList: []
    }
  },
  created () {
    this.$nextTick(() => {
      this.setTabList(this.$props.addonType)
        .then(() => {
          this.handleUrlHashChange()
        })
    })
  },
  methods: {
    onHashChange (url) {
      this.selectedTab = url.hash.substring(1)
      this.navToChild = this.tabList.findIndex(key => key.key === this.selectedTab)
      const params = {
        addon: this.selectedTab,
        segment: this.$props.segment
      }
      this.getTariffList(params)
      this.$forceUpdate()
    },
    getTariffList (params) {
      fetchTariffAddons(params).then(res => {
        this.$nextTick(() => {
          this.products = [...res.data?.products] || []
        })
      }).catch(() => {
        this.errorMsg = true
      })
    },
    setTab (tabKey) {
      if (typeof tabKey === 'number') {
        this.navToChild = tabKey
        this.selectedTab = this.tabList[tabKey].key
      } else {
        this.selectedTab = tabKey
      }

      const url = new URL(document.URL)
      url.hash = this.selectedTab
      document.location.href = url
    },
    setTabList (addonType) {
      return new Promise(resolve => {
        switch (addonType) {
          case addonTypes.mobile:
            this.tabList = [...tabListMobile]
            break
          case addonTypes.tv:
            this.tabList = [...tabListTv]
            break
          case addonTypes.box:
            this.tabList = [...tabListBox]
            break
          case addonTypes.dataRoaming:
            this.tabList = [...tabListOtherRoaming]
            break
          case addonTypes.mRoaming:
            this.tabList = [...tabListMRoaming]
            break
          case addonTypes.mSat:
            this.tabList = [...tabListMSat]
            break
          default:
            this.tabList = [...tabListMobile]
        }

        resolve()
      })
    },
    handleUrlHashChange () {
      const url = new URL(document.URL)
      if (!url.hash) {
        url.hash = this.tabList[0].key
        document.location.href = url
      } else {
        this.onHashChange(url)
      }
      window.addEventListener('hashchange', () => {
        const currentUrl = new URL(document.URL)
        this.onHashChange(currentUrl)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.tarif-tabs-page {
  display: flex;
  flex-direction: column;

  .mobile-nav {
    height: 200px;
  }

  .addon-card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    @media (map_get($breakpoints, sm)) {
      margin-top: 30px;
    }
    @media (map_get($breakpoints, lg)) {
      padding: 0 30px;
    }
    @media (map_get($breakpoints, xl)) {
      padding: 0 130px;
    }

    .addon-card {
      margin-bottom: 2rem;
    }
  }

  /deep/ .tab-select {
    ul {
      li {
        margin: 0 0;

        a {
          font-size: 14px;
        }
      }
    }
  }

  .desktop-tabs-container {
    display: none;
    @media (map_get($breakpoints, sm)) {
      display: block;
    }
    @media (map_get($breakpoints, lg)) {
      margin-top: 120px;
    }
    @media (map_get($breakpoints, xl)) {
      margin-top: 40px;
    }
  }

  .mobile-tabs-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    display: block;
    margin: 30px auto 0;
    @media (map_get($breakpoints, sm)) {
      display: none;
    }
  }
}

.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: $light-grey;
  margin: 50px auto;

  img {
    width: 50px;
    height: 50px;
    margin-bottom: 30px;
  }
}

</style>
